export default "__VITE_ASSET__5z1uGC8J__"